<template>
  <div class="room-cell-container">
    <div class="room-cell-image-container">
      <div class="view-room-icon-wrapper" @click="triggerEvent('edit')">
        <img
          alt="view-room-icon"
          class="view-room-icon"
          :src="require('@/assets/pencil-room-icon.svg')"
        />
      </div>
      <img alt="Prop Image" :src="roomImage" @error="placeholderRoom" />
    </div>
    <div :class="room.color" class="room-cell-info-occupancy">
      <div>Two Week Occupancy: {{ this.room.percentage || '0' }}%</div>
      <div>{{ this.room.percentagePrevious || '0%' }}</div>
    </div>
    <div class="room-cell-info-container">
      <div class="room-info-wrapper">
        <img src="../../assets/room.svg" />
        {{ `Room ${this.room.internalName}` }}
      </div>
      <div class="room-info-wrapper">
        <img src="../../assets/home.svg" /> {{ this.room.propertyName || '-' }}
      </div>
    </div>
    <div class="room-cell-buttons-container">
      <button @click="triggerEvent('delete')" id="deleteButton">Delete</button>
      <button @click="showRoomDetail" id="editButton">View</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RoomCell',
  components: {},
  props: {
    room: Object
  },
  methods: {
    triggerEvent(name) {
      this.$emit(name)
    },
    showRoomDetail() {
      this.$emit('showRoomDetail', this.room)
    },
    placeholderRoom(e) {
      e.target.src = require('@/assets/defaultPhotos/defaultRoom.png')
    }
  },
  computed: {
    roomImage() {
      const roomUrl =
        this.room.roomImage || require('@/assets/defaultPhotos/defaultRoom.png')
      return roomUrl
    }
  }
}
</script>

<style scoped>
.room-cell-container {
  background-color: white;
  width: 100%;
  height: 24em;
  border-radius: 8px;
  box-shadow: 0 4px 16px 0 rgba(43, 45, 55, 0.05);
  display: flex;
  flex-flow: column nowrap;
  position: relative;
}

.room-cell-image-container {
  height: 63%;
  width: 100%;
  overflow: hidden;
}
.room-cell-image-container img {
  width: 100%;
  max-height: 100%;
  object-fit: cover;
  border-radius: 2px;
  border: solid 0.5px #dfdfdf;
}
.room-cell-info-container {
  font-size: 12px;
  height: 7.5%;
  padding: 5%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
  border-bottom-style: solid;
  border-bottom-color: #f5f6f8;
  border-bottom-width: 2px;
  padding: 32px 20px;
}
.room-cell-info-container h5 {
  margin: 0px 0px 5px 0px;
  font-size: 12px;
  color: #000000;
}
.room-cell-buttons-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  padding: 5%;
  padding-left: 45%;
  height: 12%;
}

.room-cell-buttons-container button {
  width: 74px;
}
.room-cell-image-container .view-room-icon {
  border: transparent;
  cursor: pointer;
}
.view-room-icon-wrapper {
  position: absolute;
  right: 16px;
  top: 8px;
}
.room-info-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}
#editButton {
  border-radius: 4px;
  border: solid 1px var(--rentalios-dark);
  border-radius: 4px;
  background-color: #ffffff;
  color: var(--rentalios-dark);
  margin-left: 10px;
}
#editButton:hover {
  background-color: rgba(102, 176, 21, 0.1);
  cursor: pointer;
}
#deleteButton {
  border-radius: 4px;
  border: solid 1px #df000f;
  border-radius: 4px;
  background-color: #ffffff;
  color: #df000f;
}
#deleteButton:hover {
  background-color: rgba(223, 0, 15, 0.1);
  cursor: pointer;
}
.room-cell-info-occupancy {
  margin: 0 auto;
  margin-top: 6px;
  margin-bottom: 6px;
  display: flex;
  flex-direction: row;
  align-items: start;
  width: 90%;
  border-radius: 5px;
  background: rgba(204, 0, 0, 0.1);
  white-space: nowrap;
  color: rgba(204, 0, 0, 1);
}

.room-cell-info-occupancy > div {
  width: 90%;
  font-size: 12px;
  padding: 5px 7px;
}

.room-cell-info-occupancy.red {
  background: rgba(204, 0, 0, 0.1);
  color: rgba(204, 0, 0, 1);
}

.room-cell-info-occupancy.yellow {
  background: rgba(227, 151, 2, 0.1);
  color: rgba(227, 151, 2, 1);
}

.room-cell-info-occupancy.green {
  background: rgba(24, 169, 0, 0.1);
  color: rgba(24, 169, 0, 1);
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .room-cell-container {
    height: auto;
    min-height: 20em;
    margin-bottom: 16px;
  }

  .room-cell-image-container {
    height: 200px;
  }

  .room-cell-info-container {
    padding: 20px 16px;
    height: auto;
    min-height: 80px;
  }

  .room-cell-info-container h5 {
    font-size: 14px;
    margin-bottom: 8px;
  }

  .room-info-wrapper {
    font-size: 14px;
    margin-bottom: 8px;
    gap: 12px;
  }

  .room-cell-info-occupancy {
    width: 100%;
    margin: 8px auto;
    flex-direction: column;
    gap: 4px;
  }

  .room-cell-info-occupancy > div {
    width: 100%;
    font-size: 13px;
    padding: 8px 12px;
    text-align: center;
  }

  .room-cell-buttons-container {
    padding: 16px;
    padding-left: 16px;
    height: auto;
    min-height: 60px;
    justify-content: space-between;
    gap: 12px;
  }

  .room-cell-buttons-container button {
    width: 100%;
    height: 44px;
    font-size: 16px;
    border-radius: 6px;
  }

  #editButton {
    margin-left: 0;
  }

  .view-room-icon-wrapper {
    right: 12px;
    top: 12px;
  }

  .view-room-icon {
    width: 24px;
    height: 24px;
  }
}

@media (max-width: 480px) {
  .room-cell-container {
    min-height: 18em;
    margin-bottom: 12px;
  }

  .room-cell-image-container {
    height: 180px;
  }

  .room-cell-info-container {
    padding: 16px 12px;
    min-height: 70px;
  }

  .room-info-wrapper {
    font-size: 13px;
    margin-bottom: 6px;
  }

  .room-cell-info-occupancy > div {
    font-size: 12px;
    padding: 6px 10px;
  }

  .room-cell-buttons-container {
    padding: 12px;
    gap: 8px;
  }

  .room-cell-buttons-container button {
    height: 40px;
    font-size: 14px;
  }
}
</style>
